<template>
  <transition name='search-overlay'>
    <div class='search-overlay' v-if='search.active'>
      <div class='results-panel'>
        <template v-if='search.results.length'>
          <p class='results-label'>Search Results</p>
          <hr>
          <router-link
            v-for='result in search.results'
            :key='result.id'
            :to='"/" + result.uri'
            @click='search.close()'
            class='result-row'
          >› {{ result.content.title }}</router-link>
          <hr>
          <p class='results-count'>{{ search.results.length }} result{{ search.results.length !== 1 ? 's' : '' }} found</p>
        </template>
        <p class='results-label' v-else-if='search.query.length >= 2 && !search.loading'>No results found</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useSearchStore } from './SearchStore.js';
const search = useSearchStore();
</script>

<style scoped>
@import '../css/breakpoints.css';

.search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  padding-top: 16rem;
  padding-left: 8.5rem;
  padding-right: 8.5rem;
  pointer-events: none;
}

.results-panel {
  font-family: "Maison Neue Demi";
  color: var(--light);
  pointer-events: all;
}

.results-label {
  font-size: 1.2rem;
  opacity: 0.5;
  margin: 0 0 1.5rem;
}

hr {
  border: none;
  border-top: 0.1rem solid rgba(255, 255, 255, 0.3);
  margin: 0;
}

.result-row {
  display: block;
  padding: 1.4rem 0;
  color: var(--light);
  text-decoration: none;
  font-family: 'Copernicus';
  font-size: 2.5em;
  letter-spacing: 0.0015em;
  border-bottom: 0.1rem solid rgba(255, 255, 255, 0.15);
  transition: opacity 0.15s ease;
}

.result-row:hover {
  opacity: 0.6;
}

.results-count {
  font-size: 1.2rem;
  opacity: 0.5;
  margin: 1.5rem 0 0;
}

.search-overlay-enter-active,
.search-overlay-leave-active {
  transition: opacity 0.25s ease;
}

.search-overlay-enter-from,
.search-overlay-leave-to {
  opacity: 0;
}

@media (--phone) {
  .search-overlay {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}

@media print {
  .search-overlay { display: none; }
}
</style>
